export default "__VITE_ASSET__BMvBr1tr__"